import { Component, OnInit } from '@angular/core';

import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { ChangeStatusModalDirective } from '../change-status-modal.directive';
import { Store } from '@ngxs/store';
import { AuctionService, LaunchDarklyService } from 'remarketing-angular-library';

@Component({
  selector: 'app-mark-arrived-modal',
  imports: [TranslocoDirective],
  templateUrl: './mark-arrived-modal.component.html',
  styleUrl: './mark-arrived-modal.component.scss'
})
export class MarkArrivedModalComponent extends ChangeStatusModalDirective implements OnInit {

  private textArrivedVehicles: string;
  private textArrivedVehicle: string;

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.getTranslations();
  }

  get headline() {
    if (this.selectedVehicles.length > 1) {
      return this.textArrivedVehicles;
    } else {
      return this.textArrivedVehicle;
    }
  }

  getTranslations() {
    super.getTranslations();
    this.translocoService
      .selectTranslateObject('sellModule.manageInventory.actionListModal.markArrivedModal')
      .subscribe(translate => {
        this.textArrivedVehicles = translate.textArrivedVehicles;
        this.textArrivedVehicle = translate.textArrivedVehicle;
      });
  }
}
